module.exports = __webpack_public_path__ + "static/img/summitsolidLogo.35c8710c.png";